import { useModalOverlay } from "@/stores/modal-overlay-store";

/**
 * Zero-render marker that counts its host overlay in `modalOverlayStore` for as
 * long as it is mounted — see {@link useModalOverlay} for what reads it.
 *
 * Mounted as a child of the Radix overlay primitives rather than called as a
 * hook in the wrappers around them: a non-modal root makes the primitive render
 * nothing at all, so only a child is mounted exactly when a backdrop is
 * actually painted.
 */
export function ModalOverlayPresence(): null {
  useModalOverlay(true);
  return null;
}
